import { PaintedScene } from '../PaintedScene';

export const COOLING_CRUST_PHASER_KEY = 'CoolingCrustScene' as const;
export const COOLING_CRUST_MANIFEST_KEY = 's-411-cooling-crust' as const;

export class CoolingCrustScene extends PaintedScene {
  constructor() {
    super(COOLING_CRUST_PHASER_KEY, COOLING_CRUST_MANIFEST_KEY);
  }
}
